import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "datepicker-calendar",
  "use": "datepicker-calendar-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 25\" id=\"datepicker-calendar\"><path clip-rule=\"evenodd\" d=\"M.752 5.45a1.5 1.5 0 011.5-1.5h19.5a1.5 1.5 0 011.5 1.5v16.5a1.5 1.5 0 01-1.5 1.5h-19.5a1.5 1.5 0 01-1.5-1.5V5.45z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M.752 9.95h22.5M6.752 6.2V.95M17.252 6.2V.95\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/datepicker-calendar.svg
// module id = PN8s
// module chunks = 39 44